import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTipoMatricula = (): TabelaColuna => ({
  Chave: 'tipoMatricula',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 120 }}>Tipo Matrícula</div>
})
